import {Component, inject, Input} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {Table} from '@primeng/table';
import {Resources} from '@app/resources';
import {ResourceByIdPipe} from '@shared/pipes/resource-by-id.pipe';
import {TranslatePipe} from '@ngx-translate/core';
import {BasicTableComponent} from '@common/references/basic-table.component';
import {TooltipModule} from '@primeng/tooltip';
import {PTableCellValueComponent} from '@primeng/table/components/p-table-cell-value/p-table-cell-value.component';
import {ContractsService} from '@modules/universal-billing/renters/renters-details/contracts/contracts.service';
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-contracts',
  standalone: true,
  imports: [
    RouterLink,
    Table,
    ResourceByIdPipe,
    TranslatePipe,
    TooltipModule,
    PTableCellValueComponent,
    NgbTooltip
  ],
  templateUrl: './contracts.component.html',
  styleUrl: './contracts.component.scss'
})
export class ContractsComponent extends BasicTableComponent<any>{
  @Input() renterId: number;

  router = inject(Router);
  service = inject(ContractsService);

  breadCrumbItems!: Array<{}>;

  ngOnInit(): void {
    this.breadCrumbItems = [{label: 'MENU.UNIVERSAL_BILLING'}, {label: 'MENU.PAYMENTS', active: true}];
    super.ngOnInit();
  }

  getAll(params: any) {
    params.renterId = this.renterId;
    return super.getAll(params);
  }

  protected readonly Resources = Resources;
}
